// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "container--szfd";
var _5 = "content-U1rLd";
var _6 = "controls-3b4Ia";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "container", _5 as "content", _6 as "controls" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "container": _4, "content": _5, "controls": _6 }
